import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';

import ACTIVITY_TYPES from './../../constants/activityLog';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import MaterialTable from 'material-table'



const ToggleShowAllColumns = (props) => {
    const {
        showColumns,
        setShowColumns,
    } = props;

    const handleChange = (event) => {
        setShowColumns(event.target.checked);
    }

    return (
        <div>
            <Switch
                id="table-show-all-columns"
                checked={showColumns}
                onChange={handleChange}
                title="Show all columns"
                color="primary"
            />
            <Typography component="label" className="MuiFormLabel-root MuiInputLabel-shrink">
                Show all columns
            </Typography>
        </div>
    )
}

const tableRef = React.createRef();

const dateKeys = {
    start: 'enduringpromises.com.activities.table.dates.start',
    end: 'enduringpromises.com.activities.table.dates.end'
};
const sessionKeys = {
    search: 'enduringpromises.com.activities.table.search'
};

const useStyles = makeStyles(theme => ({
    formField: {
      marginLeft: theme.spacing(2),
    },
    formButton: {
        marginLeft: theme.spacing(1),
    },
}));


const MaterialTableTable = (props) => {
    const {
        dateStart,
        dateEnd,
        showColumns
    } = props;

    let history = useHistory();

    const renderWeddingColumn = rowData => {
        return rowData ? (
            <Box>
                <RouterLink to={`/admin/couples/${rowData.wedding_id}`}>{rowData.wedding_name}</RouterLink>
            </Box>
        ) : ''
    };

    let defaultColumns = [
        { title: 'Timestamp', field: 'timestamp_formatted', filtering: false, sorting: false },
        { title: 'Description', field: 'description', filtering: false, sorting: false },
        { title: 'User', field: 'user_name', filtering: false, sorting: false },
        { title: 'Wedding', field: 'wedding_name', filtering: false, sorting: false, render: rowData => renderWeddingColumn(rowData) },
        {
            title: 'Type',
            field: 'type',
            filtering: true,
            sorting: false,
            lookup: ACTIVITY_TYPES
        }
    ];

    const renderInvoiceColumn = rowData => {
        return rowData ? (
            <Box>
                <RouterLink to={`/admin/invoices/${rowData.invoice_id}`}>{rowData.invoice_pretty_name}</RouterLink>
            </Box>
        ) : ''
    };
    const renderPaymentColumn = rowData => {
        return rowData ? (
            <Box>
                <RouterLink to={`/admin/payments/${rowData.payment_id}`}>{rowData.payment_pretty_name}</RouterLink>
            </Box>
        ) : ''
    };
    const renderEventColumn = rowData => {
        return rowData ? (
            <Box>
                <RouterLink to={`/admin/officiants/events/${rowData.event_id}`}>{rowData.event_pretty_name}</RouterLink>
            </Box>
        ) : ''
    };
    const renderUnavailabilityColumn = rowData => {
        return rowData ? (
            <Box>
                <RouterLink to={`/admin/officiants/availability/${rowData.unavailability_id}`}>{rowData.unavailability_pretty_name}</RouterLink>
            </Box>
        ) : ''
    };

    if (showColumns) {
        const extraColumns = [
            { title: 'Invoice', field: 'invoice_id', filtering: false, sorting: false, render: rowData => renderInvoiceColumn(rowData) },
            { title: 'Payment', field: 'payment_id', filtering: false, sorting: false, render: rowData => renderPaymentColumn(rowData) },
            { title: 'Event', field: 'event_id', filtering: false, sorting: false, render: rowData => renderEventColumn(rowData) },
            { title: 'Unavailability', field: 'unavailability_id', filtering: false, sorting: false, render: rowData => renderUnavailabilityColumn(rowData) },
        ];
        defaultColumns = defaultColumns.concat(extraColumns);
    }

    const tableState = {
        columns: defaultColumns
    };

    function handleClick(event, rowData) {
        history.push(`/admin/couples/${rowData.id}`);
    }

    const pageSizeOptions = [15, 30, 50, 100];

    const fetchData = query =>
        new Promise((resolve, reject) => {
            let url = '/api/activity?';

            /* set the search to local storage */
            localStorage.setItem(sessionKeys.search, query.search);

            /* TOOD: find better way to do this */
            query.dateStart = query.dateStart ? query.dateStart : dateStart;
            query.dateEnd = query.dateEnd ? query.dateEnd : dateEnd;
            query.orderBy = query.orderBy ? query.orderBy : { field: 'timestamp' };

            /* TODO: use orderBy and filters */
            url += 'per_page=' + query.pageSize;
            url += '&page=' + (query.page + 1);
            url += '&search=' + query.search;
            url += '&orderBy=' + (query.orderBy ? query.orderBy.field : '');
            url += '&orderDirection=' + (query.orderDirection ? query.orderDirection : 'asc');
            url += '&dateStart=' + dateFormatter(query.dateStart);
            url += '&dateEnd=' + dateFormatter(query.dateEnd);
            if (query.filters.length) {
                url += '&' + query.filters.map(x => `${x.column.field}=`+encodeURI(x.value)).join('&')
            }
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    tableRef.current.props.options.pageSizeOptions = pageSizeOptions;
                    resolve({
                        data: result.data,
                        page: result.current_page - 1,
                        totalCount: result.total,
                    })
                })
            }
        )

    const defaultSearchText = localStorage.getItem(sessionKeys.search) || '';

    return (
        <React.Fragment>
            <MaterialTable
                title="Activity Log"
                columns={tableState.columns}
                data={fetchData}
                components={{
                    Container: Box,
                }}
                options={{
                    showTitle: false,
                    pageSize: 15,
                    pageSizeOptions: pageSizeOptions,
                    exportButton: true,
                    loadingType: 'linear',
                    emptyRowsWhenPaging: false,
                    filtering: true,
                    sorting: true,
                    debounceInterval: 600,
                    padding: 'dense',
                    searchText: defaultSearchText,
                }}
                tableRef={tableRef}
            />
        </React.Fragment>
    );
};

const dateFormatter = date => {
    return [
        date.getFullYear(), date.getMonth()+1, date.getDate()
    ].join('-');
}

const ActivityDatePicker = (props) => {
    const {
        dateStart,
        dateEnd
    } = props;

    const [selectedStartDate, setselectedStartDate] = React.useState(dateStart);
    const [selectedEndDate, setSelectedEndDate] = React.useState(dateEnd);
    const classes = useStyles();

    const handleDateChange = date => {
        setselectedStartDate(date);
    };

    const handleEndDateChange = date => {
        setSelectedEndDate(date);
    };

    const handleDateSet = () => {
        localStorage.setItem(dateKeys.start, selectedStartDate);
        localStorage.setItem(dateKeys.end, selectedEndDate);
        if (tableRef.current) {
            const query = tableRef.current.state.query;
            query.dateStart = selectedStartDate;
            query.dateEnd = selectedEndDate;
            query.page = 0;
            tableRef.current.onQueryChange();
        }
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="baseline"
            >
                <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Date filter"
                    helperText="Start Date"
                    format="MM/dd/yyyy"
                    value={selectedStartDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
                <KeyboardDatePicker
                    margin="normal"
                    id="date-end-picker-dialog"
                    format="MM/dd/yyyy"
                    helperText="End Date"
                    value={selectedEndDate}
                    onChange={handleEndDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    className={classes.formField}
                />
                <Button className={classes.formButton} onClick={handleDateSet}>Set</Button>
            </Grid>
        </MuiPickersUtilsProvider>
    );
};

const ActivitiesList = () => {
    const defaultDateStart = localStorage.getItem(dateKeys.start) ? new Date(localStorage.getItem(dateKeys.start)) : new Date();
    const defaultDateEnd = localStorage.getItem(dateKeys.end) ? new Date(localStorage.getItem(dateKeys.end)) : new Date(new Date().setMonth(new Date().getMonth() + 12));
    localStorage.setItem(dateKeys.start, defaultDateStart);
    localStorage.setItem(dateKeys.end, defaultDateEnd);

    const [dateStart, setDateStart] = React.useState(defaultDateStart);
    const [dateEnd, setDateEnd] = React.useState(defaultDateEnd);

    const [showColumns, setShowColumns] = React.useState(false);

    return (
        <div style={{ maxWidth: '100%' }}>
            <Typography variant="h6">Activity Log</Typography>
            <Grid
                container
                spacing={2}
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <Grid item xs={12} sm={12} md={8} style={{maxWidth: 622}}>
                    <ActivityDatePicker dateStart={dateStart} dateEnd={dateEnd} />
                </Grid>
            </Grid>
            <ToggleShowAllColumns showColumns={showColumns} setShowColumns={setShowColumns} />
            <MaterialTableTable dateStart={dateStart} dateEnd={dateEnd} showColumns={showColumns} />
        </div>
    );
}

export default ActivitiesList;
